import { render, staticRenderFns } from "./PageCompanyArchivesContractChange.vue?vue&type=template&id=10031e3e&scoped=true&"
import script from "./PageCompanyArchivesContractChange.vue?vue&type=script&lang=js&"
export * from "./PageCompanyArchivesContractChange.vue?vue&type=script&lang=js&"
import style0 from "./PageCompanyArchivesContractChange.vue?vue&type=style&index=0&id=10031e3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10031e3e",
  null
  
)

export default component.exports